import { render, staticRenderFns } from "./UserProfileLoader.vue?vue&type=template&id=c575c58c"
import script from "./UserProfileLoader.vue?vue&type=script&lang=ts"
export * from "./UserProfileLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports